/* Floating background shapes: each one drifts on a random path, spins in a
   random direction and fades in and out, then picks a new path. */
(function () {
  'use strict';
  const root = document.querySelector('.floaters');
  if (!root || !root.animate) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const shapes = (root.dataset.shapes || '').split('|').map((s) => s.trim()).filter(Boolean);
  if (!shapes.length) return;
  const mobile = window.matchMedia('(max-width: 749px)').matches;
  const count = Math.max(1, Math.round(parseInt(root.dataset.count || '14', 10) * (mobile ? 0.55 : 1)));
  const baseDuration = parseFloat(root.dataset.duration || '30') * 1000;
  const maxSize = parseFloat(root.dataset.size || '110') * (mobile ? 0.7 : 1);
  const rand = (min, max) => min + Math.random() * (max - min);

  function fly(el, firstRun) {
    const size = rand(maxSize * 0.4, maxSize);
    el.style.width = el.style.height = size + 'px';
    el.style.setProperty('--img', `url("${shapes[Math.floor(Math.random() * shapes.length)]}")`);

    const x0 = rand(-5, 95), y0 = rand(-5, 95);
    const angle = rand(0, Math.PI * 2), dist = rand(12, 30);
    const x1 = x0 + Math.cos(angle) * dist, y1 = y0 + Math.sin(angle) * dist;
    const xm = (x0 + x1) / 2 + rand(-8, 8), ym = (y0 + y1) / 2 + rand(-8, 8);
    const r0 = rand(0, 360);
    const spin = rand(60, 300) * (Math.random() < 0.5 ? -1 : 1);
    const peak = rand(0.55, 1);
    const duration = baseDuration * rand(0.7, 1.4);
    const pos = (x, y, r) => `translate(${x}vw, ${y}vh) rotate(${r}deg)`;

    const anim = el.animate([
      { transform: pos(x0, y0, r0), opacity: 0 },
      { transform: pos(xm, ym, r0 + spin * 0.5), opacity: peak, offset: 0.45 },
      { transform: pos(x1, y1, r0 + spin), opacity: 0 }
    ], { duration, easing: 'ease-in-out', fill: 'both', delay: firstRun ? 0 : rand(500, 4000) });

    if (firstRun) anim.currentTime = rand(0, duration); // start mid-flight so the page isn't empty
    anim.onfinish = () => fly(el, false);
  }

  for (let i = 0; i < count; i++) {
    const el = document.createElement('span');
    el.className = 'floater';
    root.appendChild(el);
    fly(el, true);
  }
})();
